const EMAIL_KEY = 'accountEmail';
export function saveEmailToStorage(email: string) {
  window.localStorage.setItem(EMAIL_KEY, email);
}

export function getEmailFromStorage(): string | null {
  return window.localStorage.getItem(EMAIL_KEY);
}

export function clearEmailFromStorage(): void {
  window.localStorage.removeItem(EMAIL_KEY);
}
